This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="basicBlock withHeader">
    <p class="header upper">{{ $t("settings.language.header") }}</p>
    <!-- Website language -->
    <p class="subheader noUpperBorder">
      {{ $t("settings.language.website") }}
    </p>
    <div
      class="blockEntry"
      v-for="language in languages"
      :class="[selectedWebsiteLanguage == language ? 'selected' : 'selectable']"
      :key="language"
      @click="selectWebsiteLanguage(language)"
    >
      {{ $t(`settings.languages.${language}`) }}
    </div>
    <!-- Programming language -->
    <p class="subheader spaceAbove">
      {{ $t("settings.language.programming") }}
    </p>
    <div
      class="blockEntry"
      v-for="language in languages"
      :class="[selectedIDELanguage == language ? 'selected' : 'selectable']"
      :key="language"
      @click="selectIDELanguage(language)"
    >
      {{ $t(`settings.languages.${language}`) }}
    </div>
    <!-- Programming style -->
    <p class="subheader spaceAbove">
      {{ $t("settings.language.programmingStyle") }}
    </p>
    <div
      class="blockEntry"
      v-for="style in programmingStyles"
      :class="[selectedProgrammingStyle == style ? 'selected' : 'selectable']"
      :key="style"
      @click="selectProgrammingStyle(style)"
    >
      <p v-if="style == 'schematically'">
        {{ $t("settings.language.schematically") }}
      </p>
      <p v-else>
        {{ $t("settings.language.typed") }}
      </p>
    </div>
    <div class="buttonsCenter spaceAbove">
      <button
        class="button success save"
        @click="
          $i18n.locale = selectedWebsiteLanguage;
          updateStore();
          updateLocalStorage();
          updateDatabase();
        "
      >
        {{ $t("settings.saveButton") }}
        <div v-if="savedSetting == 'succeeded'" class="image">
          <img src="@/assets/images/icons/Check.svg" alt="Save success icon" />
        </div>
        <div v-else-if="savedSetting == 'failed'" class="image">
          <img src="@/assets/images/icons/Cross.svg" alt="Save failed icon" />
        </div>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { userAPI } from "@/utils/apiCalls";

@Options({
  data() {
    return {
      languages: ["en", "nl"],
      selectedWebsiteLanguage: "",
      selectedIDELanguage: "",
      programmingStyles: ["schematically", "typed"],
      selectedProgrammingStyle: "",
      savedSetting: "",
    };
  },
  methods: {
    /**
     * Select website language
     * @param language Language to set
     */
    selectWebsiteLanguage(language: string): void {
      this.selectedWebsiteLanguage = language;
    },
    /**
     * Select programming language
     * @param language Language to set
     */
    selectIDELanguage(language: string): void {
      this.selectedIDELanguage = language;
    },
    /**
     * Select programming style
     * @param programmingStyle Style to set
     */
    selectProgrammingStyle(programmingStyle: string): void {
      this.selectedProgrammingStyle = programmingStyle;
    },
    //Update store with new settings
    updateStore(): void {
      this.$store.commit("setWebsiteLanguage", this.selectedWebsiteLanguage);
      this.$store.commit("setIDELanguage", this.selectedIDELanguage);
      this.$store.commit("setProgrammingStyle", this.selectedProgrammingStyle);
    },
    //Update local storage with new settings
    updateLocalStorage(): void {
      localStorage.setItem(
        "userInfo",
        JSON.stringify(this.$store.getters.getUserInfo)
      );
    },
    //Update database with new settings
    updateDatabase(): void {
      let success: Promise<number | null>;
      success = userAPI.setUserPreferences(this.$store.getters.getPreferences);

      if (success !== null) {
        this.savedSetting = "succeeded";
      } else {
        this.savedSetting = "failed";
      }
      //Timer for the action success text
      setTimeout(() => {
        this.savedSetting = "";
      }, 5000);
    },
  },
  mounted() {
    //Set settings from store
    this.selectedWebsiteLanguage = this.$store.getters.getPreferences.siteLang;
    this.selectedIDELanguage = this.$store.getters.getPreferences.ideLang;
    this.selectedProgrammingStyle =
      this.$store.getters.getPreferences.programmingStyle;
  },
})
export default class LanguageSettingsBlock extends Vue {}
</script>
